import type { UniversalWebViewRef } from '@/components/universalWebView/types'
import type { RefObject } from 'react'
import { useEffect } from 'react'
import { Keyboard, Platform } from 'react-native'

/**
 * Forwards RN keyboard show/hide into the embedded nextfe WebView so it can
 * toggle `next-app-webview-keyboard-open` on <html> (see nextfe mobileSystemLayout.css).
 * `platform` / `platformVersion` are only on these payloads (not on UniversalWebView).
 * `platformVersion`: iOS = system version string; Android = API level number (see RN Platform.Version).
 */
export function usePostKeyboardEventsToWebView(webviewRef: RefObject<UniversalWebViewRef | null>) {
  useEffect(() => {
    const payload = (event: 'RN_KEYBOARD_SHOW' | 'RN_KEYBOARD_HIDE') =>
      JSON.stringify({
        event,
        platform: Platform.OS,
        platformVersion: Platform.Version,
      })

    const show = Keyboard.addListener('keyboardDidShow', () => {
      webviewRef.current?.postMessage(payload('RN_KEYBOARD_SHOW'))
    })
    const hide = Keyboard.addListener('keyboardDidHide', () => {
      webviewRef.current?.postMessage(payload('RN_KEYBOARD_HIDE'))
    })
    return () => {
      show.remove()
      hide.remove()
    }
  }, [webviewRef])
}
